const forgotPassword = document.querySelector('#forgotPswLogin');
const recoverCancelButton = document.querySelector('#recoverCancel');
const forgotPswContainer = document.querySelector('.forgot-password');
const containerHiddenOne = document.querySelector('.container-hidden-one');
const containerHiddenTwo = document.querySelector('.container-hidden-two');

forgotPassword.addEventListener("click", function () {
  forgotPswContainer.classList.remove('tw-hidden');
  containerHiddenOne.classList.add('tw-hidden');
  containerHiddenTwo.classList.add('tw-hidden');
});

recoverCancelButton.addEventListener("click", function () {
  forgotPswContainer.classList.add('tw-hidden');
  containerHiddenOne.classList.remove('tw-hidden');
  containerHiddenTwo.classList.remove('tw-hidden');
});
document.addEventListener("DOMContentLoaded", function () {
  const passwordInput = document.getElementById("CustomerPassword");
  const toggleHidePasswordButton = document.getElementById("toggleHidePassword");
  const toggleShowPasswordButton = document.getElementById("toggleShowPassword");

  toggleHidePasswordButton.addEventListener("click", function () {
    if (passwordInput.type === "password") {
      passwordInput.type = "text";
      toggleHidePasswordButton.classList.add('tw-hidden');
      toggleShowPasswordButton.classList.remove('tw-hidden');
    }
  });
  
  toggleShowPasswordButton.addEventListener("click", function () {
    if (passwordInput.type === "text") {
      passwordInput.type = "password";
      toggleShowPasswordButton.classList.add('tw-hidden');
      toggleHidePasswordButton.classList.remove('tw-hidden');
    }
  });    
});